import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Toast } from "vant";
import store from "../store";

Vue.prototype.$axios = axios;
Vue.prototype.$apiconfg = {
  index_config: "/api/index_config", //首页筛选
  index: "/api/index", //首页
  login: "/api/login_post", //登录
  login_out: "/api/login_out", //退出
  login_send_code: "/api/login_send_code", //发送短信
  login_check: "/api/login_check", //验证是否有权限操作
  collection: "/api/collection", //收藏
  collection_update: "/api/collection_update", //收藏状态调整
  collection_check: "/api/collection_check", //收藏状态调整
  connect_check: "/api/connect_check", //标记（联系）
  connect_add: "/api/connect_add", //添加标记
  get_config_child: "/api/get_config_child", //获取测评筛选菜单
  m_index: "/api/m_index", //手机首页
  hall: "/api/hall", //企业展厅
  connect: "/api/connect", //想与我联系的企业
  wechat: "/api/wechat", //微信分享签名包
  bid_author: "/api/bid_author", //关于我的行业招标情况
  banner: "/api/banner", //Banner
  search: "/api/search", //搜索
  hall_for_rank: "/api/hall_for_rank",
};
if (process.env.NODE_ENV === "development") {
  // axios.defaults.baseURL = "https://api-syncrank.youcaiyun.com";
    axios.defaults.baseURL = 'https://api-report.dichan.com'
} else {
  axios.defaults.baseURL = "https://api-report.dichan.com";
}
axios.interceptors.request.use(function (config) {
  var Token = "token  fail && not authorization login";
  if (store.state.isLogin && store.state.auth.token) {
    Token = store.state.auth.token ? store.state.auth.token : "not token fail";
  }
  config.headers.Authorization = Token;
  return config;
});

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    var data = response.data;
    switch (data.code) {
      case 401:
        Toast.fail("您的登录好像过期了");
        store.commit("loginOut");
        router.push({ name: "Login" });
        break;
      case 1:
        if (data.msg !== "success" && data.is_pop) {
          Toast.success({ message: data.msg });
        }
        break;
      default:
        if (data.is_pop) {
          Toast.fail({ message: data.msg, duration: 4000 });
        }
        break;
    }

    return response;
  },
  function (error) {
    Toast.fail({ message: "网络连接失败，请稍后再试" });
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
